import john from '../assets/images/JohnPatti.jpg';
import joe from '../assets/images/JoeEvelius.jpg';

const info = [
  {
    title: 'John Patti',
    pic: john,
    bio: 'Multi-award-winning journalist and longtime Baltimore broadcaster, John Patti, is your host for "A Trop Rockin\' Christmas." John takes his microphone across the U.S. to bring you cherished holiday memories from some of your favorite Trop Rock artists and fans, as well as the Trop Rock Christmas music that we all love. Share future interview ideas here!',
    link: 'jvpatti@verizon.net',
  },
  {
    title: 'Joe Evelius',
    pic: joe,
    bio: 'Veteran Maryland broadcaster, Joe Evelius, is the co-founder, producer and engineer responsible for the sound of "A Trop Rockin\' Christmas." He also serves as our Music Director. Share future song ideas here!',
    link: 'joeevelius@comcast.net',
  },
];

export default info;
